import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

export const Home = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      {/* Navbar */}
      <nav className="bg-white border-b border-slate-200 py-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center">
          <div className="flex items-center gap-2 text-2xl font-bold text-brand-navy">
            <SafeIcon icon={FiIcons.FiBookOpen} className="text-brand-gold" />
            Libr Legacy
          </div>
          <div className="flex gap-4">
            <Link to="/login" className="text-slate-600 hover:text-brand-navy font-medium py-2">Log In</Link>
            <Link to="/login" className="btn-primary">Get Started</Link>
          </div>
        </div>
      </nav>

      {/* Hero */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-32">
        <div className="text-center max-w-3xl mx-auto">
          <h1 className="text-4xl lg:text-6xl font-bold text-brand-navy leading-tight mb-6">
            Secure Your Legacy With Confidence
          </h1>
          <p className="text-xl text-slate-600 mb-10">
            Professional estate planning made simple. Create your Last Will, Living Trust, and Power of Attorney with guided expertise from licensed advisors.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/login" className="btn-primary text-lg px-8 py-3">Start Planning Today</Link>
            <Link to="/login" className="btn-secondary text-lg px-8 py-3">I am an Advisor</Link>
          </div>
        </div>
      </div>

      {/* Features */}
      <div className="bg-white py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-12">
            <div className="text-center">
              <div className="w-16 h-16 bg-slate-50 rounded-full flex items-center justify-center mx-auto mb-6">
                <SafeIcon icon={FiIcons.FiShield} className="text-3xl text-brand-gold" />
              </div>
              <h3 className="text-xl font-bold text-brand-navy mb-3">Bank-Grade Security</h3>
              <p className="text-slate-600">Your most sensitive data is encrypted and stored with industry-leading security protocols.</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-slate-50 rounded-full flex items-center justify-center mx-auto mb-6">
                <SafeIcon icon={FiIcons.FiUsers} className="text-3xl text-brand-gold" />
              </div>
              <h3 className="text-xl font-bold text-brand-navy mb-3">Advisor Network</h3>
              <p className="text-slate-600">Connect with licensed professionals who review and finalize your documents.</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-slate-50 rounded-full flex items-center justify-center mx-auto mb-6">
                <SafeIcon icon={FiIcons.FiFileText} className="text-3xl text-brand-gold" />
              </div>
              <h3 className="text-xl font-bold text-brand-navy mb-3">Complete Coverage</h3>
              <p className="text-slate-600">Wills, Trusts, and specialized Immigration Power of Attorney all in one platform.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};